import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import AuthShell from "../components/AuthShell";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

function roleHome(role) {
  if (role === "admin") return "/admin";
  if (role === "licencie") return "/licencie";
  if (role === "commercant") return "/commercant";
  return "/";
}

export default function Login() {
  const navigate = useNavigate();
  const { user, loginWithToken } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  if (user) {
    return <Navigate to={roleHome(user.role)} replace />;
  }

  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const { data } = await api.post("/auth/login", {
        email: form.email.trim(),
        password: form.password,
      });
      loginWithToken(data.token, data.user);
      toast.success(`Bienvenue ${data.user.prenom}`);
      navigate(roleHome(data.user.role), { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell
      title="Connexion"
      subtitle="Accédez à votre espace Place des Énergies."
      footer={
        <span>
          Pas encore de compte&nbsp;?{" "}
          <Link to="/bootstrap" className="text-[#397DFF] font-semibold hover:underline">
            Initialiser la plateforme
          </Link>
        </span>
      }
    >
      <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
        <div className="space-y-1.5">
          <Label htmlFor="email">Email</Label>
          <Input id="email" data-testid="login-email" type="email" value={form.email} onChange={onChange("email")} required />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="password">Mot de passe</Label>
          <Input id="password" data-testid="login-password" type="password" value={form.password} onChange={onChange("password")} required />
        </div>

        {error && (
          <div data-testid="login-error" className="px-3 py-2 rounded-lg bg-[#FEF2F2] text-[#B91C1C] text-sm border border-[#FECACA]">
            {error}
          </div>
        )}

        <Button
          type="submit"
          data-testid="login-submit"
          disabled={submitting}
          className="w-full h-11 bg-[#397DFF] hover:bg-[#2860D8] text-white font-semibold rounded-xl"
        >
          {submitting ? "Connexion..." : "Se connecter"}
        </Button>

        <div className="text-center pt-1">
          <Link
            to="/forgot-password"
            data-testid="login-forgot-password"
            className="text-sm text-[#687175] hover:text-[#397DFF] hover:underline transition-colors"
          >
            Mot de passe oublié&nbsp;?
          </Link>
        </div>
      </form>
    </AuthShell>
  );
}
